import React, { memo } from 'react';
import styled from 'styled-components';
import { RECEIVE_STATUS_LABEL, getReceiveStatusColor } from '../utils/utils';
import type { ReceiveStatus } from '../types/types';

type ReceiveStatusBadgeProps = {
	status: ReceiveStatus;
};

// 기념품 수령 상태 배지 (수령 / 미수령)
const ReceiveStatusBadge = memo<ReceiveStatusBadgeProps>(({ status }) => {
	const { fontColor, bgColor } = getReceiveStatusColor(status);

	return (
		<Wrapper $fontColor={fontColor} $bgColor={bgColor}>
			{RECEIVE_STATUS_LABEL[status]}
		</Wrapper>
	);
});

ReceiveStatusBadge.displayName = 'ReceiveStatusBadge';

export default ReceiveStatusBadge;

const Wrapper = styled.div<{ $fontColor: string; $bgColor: string }>`
	min-width: 48px;
	height: 24px;
	${({ theme }) => theme.typography.caption};
	display: inline-flex;
	align-items: center;
	justify-content: center;
	padding: 0 8px;
	border-radius: 4px;
	white-space: nowrap;
	color: ${({ $fontColor }) => $fontColor};
	background-color: ${({ $bgColor }) => $bgColor};
`;
